/** ICS calendar API route for HDE events. */
const HDE_EVENT_CALENDAR_ICS_API_ROUTE = '/remix-api/hde/event';

/** Build ICS download URL for an HDE event. Safe to use in client components. */
export function getHdeEventCalendarIcsUrl(eventId: string): string {
    return `${HDE_EVENT_CALENDAR_ICS_API_ROUTE}/${eventId}/calendar/ics`;
}
